import { useCallback, useMemo } from 'react'
import { useTranslations } from 'next-intl'

export default function useErrorMessages() {
  const t = useTranslations('errors.common')
  const defaultMessage = t('default')
  const errorCodeMap: Record<string, string> = useMemo(
    () => ({
      400: t('invalid_input'),
      401: t('unauthorized'),
      403: t('forbidden'),
      404: t('not_found'),
      429: t('too_many_requests'),
      500: t('unable_to_process'),
      502: t('bad_gateway_server_error'),
      503: t('service_unavailable'),
    }),
    [t]
  )

  const getErrorCodeMessage = useCallback(
    (errorCode?: string) => {
      if (!errorCode) {
        return defaultMessage
      }

      const [, code] = errorCode.split('_')

      return code in errorCodeMap ? errorCodeMap[code] : defaultMessage
    },
    [defaultMessage, errorCodeMap]
  )

  const getStatusCodeMessage = useCallback(
    (statusCode?: number) => {
      if (!statusCode) {
        return defaultMessage
      }

      return statusCode in errorCodeMap ? errorCodeMap[statusCode] : defaultMessage
    },
    [defaultMessage, errorCodeMap]
  )

  return { getErrorCodeMessage, getStatusCodeMessage }
}
